module.exports = __webpack_public_path__ + "img/J13213.619135d1.png";